import React, { Component } from "react";
import { loadModules, setDefaultOptions } from "esri-loader";

setDefaultOptions({ version: "4.14" });

export class ManifestMapArcGIS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      places: [],
      pagination: null,
      isFetching: false,
      showInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      genPosition: null,
      trans1Position: null,
      trans2Position: null,
      tsdfPosition: null,
      altTsdfPosition: null,
      markers: [],
      genMarker: null,
      trans1Marker: null,
      trans2Marker: null,
      tsdfMarker: null,
      altTsdfMarker: null,
      bounds: null,
      showingInfoWindow: false,
      windowPosition: null,
      showInfoWindow: false,
      current_id: "",
      lastSelection: null,
      currentManifest: null,
      currentGenerator: null,
      currentTSDF: null,
      curvature: 0.5,
      manifestPath: [],
      intialCenter: {},
    };
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      currentManifest: this.props.Manifest.MANIFEST_ID,
      currentTSDF: this.props.Manifest.TSDF_EPA_ID,
    });
    if (this.props.TSDF.length !== 0) {
      this.createMap();
    }

    // console.log("this.state", this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.Manifest &&
        this.props.Manifest.MANIFEST_ID !== this.state.currentManifest) ||
      this.props.TSDF.EpaId !== this.state.currentTSDF ||
      this.props.GENERATOR.EpaId !== this.state.currentGenerator
    ) {
      this.setState(
        {
          currentManifest: this.props.Manifest.MANIFEST_ID,
          currentGenerator: this.props.GENERATOR.EpaId,
          currentTSDF: this.props.TSDF.EpaId,
        },
        () => {
          //this.createMarkers();
        }
      );
    }
  }

  drawArrow = (Graphic, Polyline, SimpleLineSymbol, PMS) => {
    //Draw arrow line
    let start = {
      x: this.state.genPosition.lng,
      y: this.state.genPosition.lat,
      spatialReference: { wkid: 4326 },
    };
    // let endX = this.state.genPosition.lng > this.state.tsdfPosition.lng ? this.state.tsdfPosition.lng + 0.005 : this.state.tsdfPosition.lng - 0.005;
    // let endY = this.state.genPosition.lat > this.state.tsdfPosition.lat ? this.state.tsdfPosition.lat + (0.05 * this.view.zoom) : this.state.tsdfPosition.lat - (0.5 * this.view.zoom);
    // let end = { x: endX, y: endY };

    let end = {
      x: this.state.tsdfPosition.lng,
      y: this.state.tsdfPosition.lat,
    };

    // var screenStart = this.view.toScreen(start);
    // var screenEnd = this.view.toScreen({ x: this.state.tsdfPosition.lng, y: this.state.tsdfPosition.lat, spatialReference: { wkid: 4326 } })
    // console.log("screenStart", screenStart);
    // console.log("screenEnd", screenEnd);

    // if (screenStart) {
    //   let screenEndX = this.state.genPosition.lng > this.state.tsdfPosition.lng ? screenEnd.x + 0.005 : screenEnd.x - 0.005;
    //   let screenEndY = this.state.genPosition.lat > this.state.tsdfPosition.lat ? screenEnd.y + (0.05 * this.view.zoom) : screenEnd.y - (0.05 * this.view.zoom);

    //   end = this.view.toMap({ x: screenEndX, y: screenEndY });
    // }

    let lineGraphic = new Graphic({
      geometry: new Polyline({
        paths: [
          [start.x, start.y],
          [end.x, end.y],
        ],
        spatialReference: { wkid: 4326 },
      }),
      symbol: new SimpleLineSymbol({
        color: "black",
        width: "3px",
        style: "solid",
      }),
    });

    let dx = end.x - start.x,
      dy = end.y - start.y,
      rads = Math.atan2(dy, dx);

    if (rads < 0) {
      rads = Math.abs(rads);
    } else {
      rads = 2 * Math.PI - rads;
    }

    let degrees = (rads * 180) / Math.PI + 180;

    let arrowHeadGraphic = new Graphic({
      symbol: new PMS({
        url:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTcxLjgxNXB4IiBoZWlnaHQ9IjU3MS44MTVweCIgdmlld0JveD0iMCAwIDU3MS44MTUgNTcxLjgxNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTcxLjgxNSA1NzEuODE1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTExNy41MTgsMjk2LjA0MmwzMzMuMTYxLDI3Mi4xMzJjOC4yODYsNi42NDYsMTIuMDYyLDMuOTQxLDguNDMtNi4wNGwtODguNDQyLTI2MC4wNDkgICAgYy0zLjYzLTkuOTgxLTMuNTk2LTI2LjE1NiwwLjA3Ni0zNi4xMjNsODguMjktMjU2LjI2YzMuNjcyLTkuOTY2LTAuMTAxLTEyLjcwMi04LjQzMS02LjExTDExNy41OTQsMjcyLjA3ICAgIEMxMDkuMjY1LDI3OC42NjEsMTA5LjIzMSwyODkuMzk1LDExNy41MTgsMjk2LjA0MnoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4=",
        angle: degrees,
      }),
      geometry: {
        type: "point",
        x: end.x,
        y: end.y,
      },
    });

    return [lineGraphic, arrowHeadGraphic];
  };

  createMap = () => {
    if (
      (this.props.GENERATOR.DDLatitude === 0 &&
        this.props.GENERATOR.DDLongitude === 0) ||
      this.props.GENERATOR.DDLatitude <= 10 ||
      this.props.GENERATOR.DDLatitude >= 50 ||
      this.props.GENERATOR.DDLongitude <= -180 ||
      this.props.GENERATOR.DDLongitude >= -45
    ) {
    } else {
      this.state.genPosition = {
        lat: this.props.GENERATOR.DDLatitude,
        lng: this.props.GENERATOR.DDLongitude,
      };

      if (
        this.props.TSDF.EpaId === this.props.GENERATOR.EpaId ||
        (this.props.TSDF.DDLatitude === 0 &&
          this.props.TSDF.DDLongitude === 0) ||
        this.props.TSDF.DDLatitude <= 10 ||
        this.props.TSDF.DDLatitude >= 50 ||
        this.props.TSDF.DDLongitude <= -180 ||
        this.props.TSDF.DDLongitude >= -45
      ) {
      } else {
        this.state.tsdfPosition = {
          lat: this.props.TSDF.DDLatitude,
          lng: this.props.TSDF.DDLongitude,
        };
      }

      // lazy load the required ArcGIS API for JavaScript modules and CSS
      loadModules(
        [
          "esri/WebMap",
          "esri/views/MapView",
          "esri/layers/FeatureLayer",
          "esri/Basemap",
          "esri/widgets/BasemapToggle",
          "esri/layers/support/Field",
          "esri/geometry/Point",
          "esri/symbols/TextSymbol",
          "esri/Graphic",
          "esri/geometry/Polyline",
          "esri/symbols/LineSymbol",
          "esri/symbols/WebStyleSymbol",
          "esri/symbols/SimpleLineSymbol",
          "esri/symbols/PictureMarkerSymbol",
        ],
        { css: true }
      ).then(
        ([
          WebMap,
          MapView,
          FeatureLayer,
          Basemap,
          BasemapToggle,
          Field,
          Point,
          TextSymbol,
          Graphic,
          Polyline,
          LineSymbol,
          WebStyleSymbol,
          SimpleLineSymbol,
          PMS,
        ]) => {
          const map = new WebMap({
            // portalItem: {
            //   id: 'da83595b291349b79c7e56e5fabc5fde'
            // },
            // basemap: Basemap.fromId("streets-night-vector"),
            basemap: Basemap.fromId("streets-navigation-vector"),
          });

          this.setState({
            map: map,
          });

          //2d View
          this.view = new MapView({
            container: this.mapRef.current,
            map: this.state.map,
            //center: [-122.057281, 38.250313],
            //center: [this.props.DD_Longitude, this.props.DD_Latitude],
            zoom: 5,
            highlightOptions: {
              fillOpacity: 0,
              color: [50, 50, 50],
            },
            popup: {
              dockEnabled: true,
              dockOptions: {
                position: "top-right",
                breakpoint: false,
              },
            },
            // constraints: {
            //   maxScale: 35000,
            //   minScale: 10000000
            // }
          });

          var basemapToggle = new BasemapToggle({
            view: this.view,
            nextBasemap: "hybrid",
          });
          this.view.ui.add(basemapToggle, "bottom-left");

          // const textSymbol = new TextSymbol({
          //   color: '#ff0000',
          //   fillColor: '#ff0000',
          //   text: '\ue61e',  // esri-icon-map-pin
          //   font: {  // autocast as new Font()
          //     size: 24,
          //     family: 'CalciteWebCoreIcons'
          //   }
          // });

          //https://developers.arcgis.com/javascript/latest/guide/esri-web-style-symbols-2d/
          var webStyleSymbol = new WebStyleSymbol({
            name: "esri-pin-1",
            color: "#7A003C",
            styleName: "Esri2DPointSymbolsStyle",
          });

          const fields = [
            new Field({
              name: "ObjectID",
              alias: "ObjectID",
              type: "oid",
            }),
            new Field({
              name: "FacName",
              alias: "FacName",
              type: "string",
            }),
            new Field({
              name: "EpaId",
              alias: "EpaId",
              type: "string",
            }),
          ];

          const facilityRenderer = {
            type: "simple",
            // symbol: {
            //   type: "simple-marker",
            //   size: 1,
            //   //color:[0, 255, 255],
            //   color: [0, 255, 255],
            //   outline: null
            // }
            //symbol: textSymbol
            symbol: webStyleSymbol,
          };

          const facilities = [
            {
              geometry: {
                type: "point",
                x: this.state.genPosition.lng,
                y: this.state.genPosition.lat,
              },
              attributes: {
                ObjectID: 0,
                // FacName: data.FacName,
                // EpaId: data.EpaId
              },
            },
            {
              geometry: {
                type: "point",
                x: this.state.tsdfPosition.lng,
                y: this.state.tsdfPosition.lat,
              },
              attributes: {
                ObjectID: 1,
                // FacName: data.FacName,
                // EpaId: data.EpaId
              },
            },
          ];

          const facilityLayer = new FeatureLayer({
            title: "facility layer",
            source: facilities,
            fields: fields,
            ObjectIDField: "ObjectID",
            renderer: facilityRenderer,
          });

          facilityLayer.on("layerview-create", (e) => {
            this.setState({
              isFetching: false,
            });
            facilityLayer.queryExtent().then((response) => {
              if (response.count === 1) {
                this.view.goTo({
                  target: facilities[0],
                  zoom: 20,
                });
              } else {
                this.view.goTo(response.extent.expand(1.3));
              }
            });
          });

          // console.log("genX", this.state.genPosition.lng);
          // console.log("genY", this.state.genPosition.lat);
          // console.log("tsdfX", this.state.tsdfPosition.lng);
          // console.log("tsdfY", this.state.tsdfPosition.lat);
          // console.log("MapView.zoom", this.view.zoom);

          let arrow = this.drawArrow(Graphic, Polyline, SimpleLineSymbol, PMS);

          this.view.watch("zoom", (event) => {
            // console.log("event", event);
            this.view.graphics.removeAll();
            let arrow = this.drawArrow(
              Graphic,
              Polyline,
              SimpleLineSymbol,
              PMS
            );
            this.view.graphics.addMany(arrow);
          });

          this.setState(
            {
              facilityLayer: facilityLayer,
            },
            () => {
              this.view.graphics.addMany(arrow);
              this.state.map.add(this.state.facilityLayer);
            }
          );
        }
      );
      this.setState({
        view: this.view,
      });
    }
  };

  render() {
    return <div id="mapDiv" className="webmap-manifestmap" ref={this.mapRef} />;
  }
}

export default ManifestMapArcGIS;
